<template>
  <div>
    <div :id="isChangeFooter?'transCC-change':'transCC'">
      <div class="transCC-outbox">
        <div class="transCC-box-top">
          <div class="transCC-box2 transCC-box">
            <NewTransccTopLine />
          </div>
        </div>
        <div class="transCC-box-middle">
          <div class="transCC-box-middle-left">
            <div class="transCC-box3 transCC-box">
              <!-- k线 -->
              <QuotationLineCC v-if="!isChangeFooter" ref="QuotationLineCC" :trans-c-c-default-t-v-style="defaultTVStyle" @setDefaultTVStyle="setDefaultTVStyle"></QuotationLineCC>
              <QuotationLineCCLong v-else ref="QuotationLineCC" :trans-c-c-default-t-v-style="defaultTVStyle" @setDefaultTVStyle="setDefaultTVStyle"></QuotationLineCCLong>
            </div>
          </div>
          <div class="transCC-box-middle-right">
            <div class="transCC-box-middle-right_goodsMsg">
                <div class="transCC-box-middle-right_goodsMsg--tabs">
                  <div class="transCC-box" :class="currentName=='pk'?'transCC-box6':'tab-transCC-box6'">
                    <!-- 盘口 公告 简报 明细 -->
                    <Tabs @changTab="changTabSty" />
                  </div>
                </div>
                <div class="transCC-box-middle-right_goodsMsg--list" v-if="currentName=='pk'">
                    <div class="transCC-box4 transCC-box">
                      <!-- 委托列表 -->
                      <TopViewCC></TopViewCC>
                    </div>
                    <div class="transCC-box5 transCC-box">
                      <!-- 盘口明细 -->
                      <NewGoodsMsg style="margin-top: 6px;padding:4px 0" />
                    </div>
                </div>
            </div>
            <div class="transCC-box-middle-right_transView">
                <div class="transCC-box-middle-right_transView--header">
                    <div class="newtabs_btn mxFrant" >
                      明细
                    </div>
                    <button class="more" @click="gotoMX()">查看更多</button>
                </div>
                <div class="transCC-box-middle-right_transView--list">
                  <div class="transCC-box transCC-box8">
                    <!-- <TransViewCC current-height="394px" /> -->
                    <TransViewCC current-height="100%" />
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="changeLine" @click="changeClick">切换</div>
        <div class="transCC-box9 transCC-box">
          <div class="changeBtn">
            <img v-if="!isChangeFooter" src="../../assets/images/newfooter-2.png" @click="changeClick">
            <img v-else src="../../assets/images/newfooter-1.png" @click="changeClick">
          </div>
        </div>
        <div class="transCC-box-bottom" v-if="!isChangeFooter">
          <div class="transCC-box7 transCC-box">
            <NewFooter />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import NoticeCC from './notice/NoticeCC'

import TopViewCC from './topview/TopViewCC'
import TransViewCC from './transview/TransViewCC'
import QuotationLineCC from './quotationline/QuotationLineCC' // hqchart版本
import QuotationLineCCLong from './quotationline/QuotationLineCC_Long' // hqchart版本
// import QuotationLineCC from './quotationline/QuotationLineCC1' // tradingview版本
// import QuotationLineCCLong from './quotationline/QuotationLineCC_Long1' // tradingview版本
// 新增 UI
import NewTransccTopLine from './new/NewTransccTopLine.vue'
import NewGoodsMsg from './new/NewGoodsMsg.vue'
import Tabs from './notice/Tabs.vue'
import NewFooter from './new/NewFooter.vue'
export default {
  name: 'TransCC',
  components: {
    // NoticeCC,

    TopViewCC,
    TransViewCC,
    QuotationLineCC,
    QuotationLineCCLong,
    NewTransccTopLine,
    NewGoodsMsg,
    Tabs,
    NewFooter
  },
  data() {
    return {
      currentName: 'pk',
      isChangeFooter: false,
      defaultTVStyle: null,
      changeTime: 0,
      maxChangeTime: 4 // 必须是偶数!!
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'marketDetails']),
    isLogin() {
      if (this.sessionInfoGetter && this.sessionInfoGetter['sessionStr'] && this.sessionInfoGetter['userId']) {
        return true
      }
      return false
    }
  },
  created() {
    if (this.$route.query.ids == 1) {
      this.defaultTVStyle = JSON.parse(localStorage.getItem('__local_defaultTVStyle'))
    }
  },
  mounted() {
    // this.isChangeFooter = localStorage.getItem('__local_isChangeFooter') == 'true' ? true : false
    this.getIdentificationStatus()
  },
  beforeCreate() {
  },
  methods: {
    gotoMX() {
      this.$router.push('/TransViewMore')
    },
    setDefaultTVStyle(defaultTVStyle) {
      this.defaultTVStyle = defaultTVStyle
    },
    // 拉伸功能
    changeClick() {
      this.isChangeFooter = !this.isChangeFooter
      this.changeTime++
      if (this.changeTime >= this.maxChangeTime) {
        // localStorage.setItem('__local_isChangeFooter', this.isChangeFooter)
        localStorage.setItem('__local_defaultTVStyle', JSON.stringify(this.defaultTVStyle))
        this.$router.go(0)
      }
    },
    getIdentificationStatus() {
      BaseApi.findBaseUserAuditByUserId().then((response) => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (
            value !== null &&
            JSON.stringify(value) !== '{}' &&
            value !== '0'
          ) {
            if (value.auditStatus === 1) {
              // //  '未审核'/'已认证'
              if (value.auditType === 'P') {
                // 个人
                this.$store.commit('setOwnSideName', value.name)
              } else if (value.auditType === 'O') {
                // 企业
                this.$store.commit('setOwnSideName', value.legalPersonName)
              }
            } else {
              // '已驳回'
              this.$store.commit('setOwnSideName', 'XXX')
            }
          } else {
            this.$store.commit('setOwnSideName', 'XXX')
          }
        } else {
          this.$toast(message)
        }
      })
    },
    changTabSty(name) {
      this.currentName = name
    }
  }
}
</script>
<style scoped lang='scss'>
$cell_top:50px;
$cell_middle:536px;
$cell_bottom:399px;
#transCC {
  background-color: #000000;
  .transCC-outbox {
    position: relative;
    // height: 926px;
    // height: calc(#{$cell_top} + #{$cell_middle} + #{$cell_bottom}) !important;
    .transCC-box-top{
      margin: 3px 0;
      background: #161719;
    }
    .transCC-box-middle{
      min-width: 1458px;
      display: flex;
      height: $cell_middle;
      justify-content: space-between;
      border: 1px solid rgba($color: #dfdfdf, $alpha: 0.3);
      border-bottom: none;
      &-left{
        flex-grow: 1;
        min-width: 720px;
      }
      &-right{
        display: flex;
        
         &_goodsMsg{
            width: 374px;
            height: 100%;
            background: #121212;
         
            overflow: hidden;
            &--list{
              height: 100%;
              padding: 10px;
              display: flex;
              flex-direction: column;
              .transCC-box4{
                height: 242px;
                margin-top: 4px;
                border-bottom: 1px solid rgba($color: #ffffff, $alpha: 0.3);
                padding-bottom: 10px;
              }
               .transCC-box5{
                height: 240px;
              }
            }
         }
         &_transView{
          flex: 1;
          width:270px;
          height: 100%;
          margin-left: 4px;
          background: #121212;
          &--header{
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            line-height: 40px;
            background-color: #121212;
            border-bottom: 1px solid rgba($color: #ffffff, $alpha: 0.1);
            padding: 0 20px;
            .mxFrant{
            font-family: Source Han Sans SC;
            font-weight: 500;
            font-size: 14px;
            color: #DFDFDF;
            border-bottom: 2px solid #ffffff;
            }
            .more{
              cursor: pointer;
              width: 78px;
              height: 28px;
              background: rgba($color: #868686, $alpha: 0.2);
              border-radius: 4px;
              border: 1px solid rgba($color: #ffffff, $alpha: 0.2);
              font-family: Source Han Sans SC;
              font-weight: 400;
              font-size: 12px;
              color: #8D8D8D;
            }
          }
          &--list{
            box-sizing: border-box;
              height: calc(100% - 40px);
              padding: 10px 4px;
            }
         }
      }
    }
    .transCC-box-bottom{
      // box-sizing: border-box;
      height: $cell_bottom;
      margin-top: 3px;
      background: #000000;
    }
  }

    .transCC-box{
      display: inline-block;
      &.transCC-middle-right-box{
        position: absolute;
        top: calc(#{$cell_top});
        right: 0;
      
      }
    }
    .transCC-box1{
      position: absolute;
      top: 0;
      left: 0;
      width: 352px;
      height: 501px;
    }
    .transCC-box2{
      // position: absolute;
      // top: 3px;
      // left: 0;
      width: 100%;
      height: $cell_top;
    }
    .transCC-box3{
      // position: absolute;
      // // top: 149px;
      // top: calc(#{$cell_top});
      // left: 0;
      // width:  calc(100% - 498px);
      width: 100%;
      height: $cell_middle; // + 147
    }
    .transCC-new-box{
      position: absolute;
      top: 49px;
      right: 0;
      width: 361px;
      height: $cell_middle;
    }
    // .transCC-box4{
    //   position: absolute;
    //   top: 191px;
    //   right: 198px;
    //   width:294px;
    //   height: 210px;
    // }
    // .transCC-box5{
    //   position: absolute;
    //   top: 395px;
    //   right: 198px;
    //   width:294px;
    //   height: 260px;
    // }
    .transCC-box6{
      // position: absolute;
      // right: 0;
      // top: 148px;
      width: 100%;
      height: 28px;
      // z-index: 100;
    }
    .tab-transCC-box6{
      // position: absolute;
      // right: 0;
      // top: 49px;
      width: 100%;
      height: 536px;
      // z-index: 1010;
    }
    .transCC-box8{
    
      width: 100%;
      height: 100%;

    }
    .transCC-box8::after{
      content:'';
      position: absolute;
      left:0;
      top:0;
      height:470px;
      width:2px;
      background: #1b1d24;
      // background: linear-gradient(45deg, rgba(94, 101, 146, 0.4) 0%, #464C74 62%, rgba(48, 53, 89, 0.4) 100%);
    }
    .transCC-box7{
      height: $cell_bottom;
      width: 100%;
      
    }
    .transCC-box9 {
      position: absolute;
      right:0;
      left: 0;
      top: 596px;
      height: 14px;
      z-index: 100;
      text-align: center;
      cursor: pointer;
    }

}
#transCC-change {
  background-color: #000000;
  .transCC-outbox {
    position: relative;
    height: calc(100vh - 41.56px);
    overflow: hidden;
    .transCC-box-top{
      margin: 3px 0;
      background: #161719;
    }
    .transCC-box-middle{
      min-width: 1458px;
      display: flex;
      // height: $cell_middle;
      justify-content: space-between;
      border: 1px solid rgba($color: #dfdfdf, $alpha: 0.3);
      border-bottom: none;
      &-left{
        flex-grow: 1;
        min-width: 720px;
      }
      &-right{
        position: absolute;
        top: 49px;
        right: 0;
        width: 361px;
        height: 100%;
        
        display: flex;
         &_goodsMsg{
            width: 374px;
            height: 100%;
            background: #121212;
         
            overflow: hidden;
            &--list{
              height: 100%;
              padding: 10px;
              display: flex;
              flex-direction: column;
              .transCC-box4{
                height: 242px;
                margin-top: 4px;
                border-bottom: 1px solid rgba($color: #ffffff, $alpha: 0.3);
                padding-bottom: 10px;
              }
               .transCC-box5{
                height: 240px;
              }
            }
         }
         &_transView{
          position: absolute;
          right: 0;
          top: 535px;
          width: 361px;
          height: calc(100vh - 439px);
          z-index: 100;

          flex: 1;
          width:361px;
          height: 100%;
          margin-left: 4px;
          background: #121212;
          &--header{
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            line-height: 40px;
            background-color: #121212;
            border-bottom: 1px solid rgba($color: #ffffff, $alpha: 0.1);
            padding: 0 20px;
            .mxFrant{
            font-family: Source Han Sans SC;
            font-weight: 500;
            font-size: 14px;
            color: #DFDFDF;
            border-bottom: 2px solid #ffffff;
            }
            .more{
              cursor: pointer;
              width: 78px;
              height: 28px;
              background: rgba($color: #868686, $alpha: 0.2);
              border-radius: 4px;
              border: 1px solid rgba($color: #ffffff, $alpha: 0.2);
              font-family: Source Han Sans SC;
              font-weight: 400;
              font-size: 12px;
              color: #8D8D8D;
            }
          }
          &--list{
            box-sizing: border-box;
            height: calc(100% - 610px);
            padding: 10px 4px;
          }
         }
      }
    }
    .transCC-box{
      display: inline-block;
    }
    .transCC-box2{
      position: absolute;
      top: 3px;
      left: 0;
      width: 100%;
      height: 40px;
    }
    // K线
    .transCC-box3{
      position: absolute;
      top: 49px;
      left: 0;
      width:  calc(100% - 367px);
      height: calc(100vh - 42px - 84px);
      background: #141517;
    }
    .transCC-new-box{
      position: absolute;
      top: 49px;
      right: 0;
      width: 361px;
      height: 583px;
      overflow: hidden;
    }
    // // top3
    // .transCC-box4{
    //   position: absolute;
    //   top: 85px;
    //   right: 0px;
    //   width:361px;
    //   height: 242px;
    // }
    // // 盘口 明细
    // .transCC-box5{
    //   position: absolute;
    //   top: 330px;
    //   right: 0px;
    //   width: 361px;
    //   height: 240px;
    // }
    // tabs切换组件 收起形态
    // .transCC-box6{
    //   position: absolute;
    //   right: 0;
    //   // top: calc(100vh - 41.56px - 16px - 28px);
    //   top: 49px;
    //   width: 361px;
    //   height: 28px;
    //   z-index: 100;
    // }
    // // tabs切换组件 展开形态
    // .tab-transCC-box6{
    //   position: absolute;
    //   right: 0;
    //   // top: 493px;
    //   top: 49px;
    //   width: 361px;
    //   height: calc(100vh - 439px);
    //   z-index: 1010;
    // }
    .transCC-box6{
      // position: absolute;
      // right: 0;
      // top: 148px;
      width: 100%;
      height: 28px;
      // z-index: 100;
    }
    .tab-transCC-box6{
      // position: absolute;
      // right: 0;
      // top: 49px;
      width: 100%;
      height: 536px;
      // z-index: 1010;
    }
    // 实时成交信息
    // .transCC-box-middle-right_transView{
    //   position: absolute;
    //   right: 0;
    //   top: 535px;
    //   width: 361px;
    //   height: calc(100vh - 439px);
    //   z-index: 100;
    // }
    // .transCC-box8{
    //   position: absolute;
    //   right: 0;
    //   top: 535px;
    //   width: 361px;
    //   height: calc(100vh - 439px);
    //   z-index: 100;
    // }
    .transCC-box8{
      width: 100%;
      // height: 100%;
      height: calc(100vh - 700px);
      // background: red;
    }
    .transCC-box8::after{
      content:'';
      position: absolute;
      left:0;
      top:0;
      height:470px;
      width:2px;
      background: #1b1d24;
      // background: linear-gradient(45deg, rgba(94, 101, 146, 0.4) 0%, #464C74 62%, rgba(48, 53, 89, 0.4) 100%);
    }
    .transCC-box7{
      position: absolute;
      top: 100000px;
      left: 0;
      width: 0;
      height: 0;
    }
    .transCC-box9 {
      position: absolute;
      right:0;
      left: 0;
      top: calc(100vh - 60px - 16px);
      height: 14px;
      z-index: 100;
      text-align: center;
    }
  }
}
.transCC-box9 {
  position: absolute;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    height: 14px;
  }
}
</style>
<style>
#transcc_new_newfooter .el-pagination button:disabled,
#transcc_new_newfooter .el-pagination .btn-prev,
#transcc_new_newfooter .el-pagination .btn-next,
#transcc_new_newfooter .el-pager li,
#transcc_new_newfooter .el-pagination__editor.el-input .el-input__inner,
#transcc_new_newfooter .el-pagination .el-select .el-input .el-input__inner,
#transcc_new_newfooter .el-table table tr,
#transcc_new_newfooter .el-table th,
#transcc_new_newfooter .el-table {
  background-color: #141517;
}
#transcc_new_newfooter
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped.current-row
  td,
#transcc_new_newfooter .el-table__body tr.current-row > td,
#transcc_new_newfooter .el-table__body tr.hover-row.current-row > td,
#transcc_new_newfooter .el-table__body tr.hover-row.el-table__row--striped.current-row > td,
#transcc_new_newfooter .el-table__body tr.hover-row.el-table__row--striped > td,
#transcc_new_newfooter .el-table__body tr.hover-row > td {
  background-color: #141517;
}
#transcc_new_newfooter .el-button--text {
  padding: 0;
}
#transcc_new_newfooter .el-table__empty-block{
  min-height:180px;
}
#transcc_new_newfooter .el-table--scrollable-x .el-table__body-wrapper{
  /* height:300px !important; */
  overflow: auto !important;
}
#transcc_new_newfooter .el-table--enable-row-hover .el-table__body tr:hover>td{
background-color: #212e3e !important;
}
</style>

